<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form ref="searchForm" v-model="searchForm" :inline="true" class="demo-form-inline">
          <el-row>
            <el-col :span="12">
              <el-form-item label="关键字">
                <el-input v-model="searchForm.keyWord" size="small" clearable />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="handleSearch">查找</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-button style="float:right" type="primary" size="small" @click="handleAddNew">新增</el-button>
            </el-col>
          </el-row>
          <el-table
            class="table-list"
            :border="true"
            :data="tableData"
            style="width: 100%"
            @sort-change="handleResort"
          >
            <!-- 序号 -->
            <el-table-column label="序号" type="index" width="50px" align="right" />

            <el-table-column label="职位名称" prop="recruitName" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="职位类型" prop="recruitTypeDictName" width="150px" />
            <el-table-column label="职位信息" prop="recruitInfo" width="250px" :show-overflow-tooltip="true" />
            <el-table-column label="专业" prop="profession" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="学位要求" prop="degree" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="工作年限要求" prop="workYearShow" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="岗位要求" prop="requirement" width="250px" :show-overflow-tooltip="true" />
            <el-table-column label="课题组负责人" prop="ketizuFuzeren" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="课题组简介" prop="ketizuJianjie" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="研究领域" prop="yanjiuLingyu" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="所属学科" prop="suoshuXueke" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="研究方向" prop="yanjiuFangxiang" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="所属单位" prop="suoshuDanwei" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="工作地点" prop="gongzuoDidian" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="薪资待遇" prop="daiyu" width="150px" :show-overflow-tooltip="true" />
            <el-table-column label="发布期间" prop="publishDTShow" width="150px" :show-overflow-tooltip="true" />

            <el-table-column
              fixed="right"
              label="操作"
              width="190"
              align="center"
            >
              <template slot-scope="scope">
                <span>
                  <el-button
                    type="text"
                    size="mini"
                    plain
                    @click.stop="handleEdit( scope.row,scope.$index)"
                  >修改</el-button>

                  <el-button
                    type="text"
                    size="mini"
                    @click.stop="handleDel(scope.row)"
                  >删除</el-button>
                  <el-button type="text" size="mini" @click.stop="handleSendDetail(scope.row)">
                    投递详情
                  </el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next,total,sizes"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            :total="totalCount"
            @size-change="handleSizeChange"
            @current-change="handleChangePage"
          />

        </el-form>
      </div>
    </div>
    <dtl v-model="dtlShow" :entity-key="dtlKey" @save-success="handleSearch" />
  </div>
</template>
<script>
import dtl from './recruit-detail'
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
export default {
  components: { dtl },
  data() {
    return {
      dtlShow: false,
      dtlKey: null,
      moduleCode: 'gr07',
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        keyWord: '',
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: ''
      }

    }
  },
  mounted() {
    this.handleSearch()
  },
  methods: {
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    /** 查询 */
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/GR07/GetGR07sForMe'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.totalCount = res.data.result.totalCount
          that.tableData = res.data.result.items
        })
    },

    /** 新增 */
    handleAddNew() {
      this.dtlKey = null
      this.dtlShow = true
    },
    /** 修改 */
    handleEdit(row) {
      this.dtlKey = row.id
      this.dtlShow = true
    },
    /** 删除 */
    handleDel(row) {
      const that = this
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/GR07/DeleteGR07'
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          that.handleSearch()
        })
      })
    },
    /** 投递详情 */
    handleSendDetail(row) {
      this.$router.push({
        name: 'gr0703',
        params: {
          recruitId: row.id
        }
      })
    }
  }

}
</script>
